interface VideoBackgroundProps {
  videoSrc?: string
}

export const VideoBackground = ({ videoSrc = "/Futuristic_Enterprise_Transformation_Video.mp4" }: VideoBackgroundProps) => {
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden bg-black">
      {/* Cinematic Vignette Overlay to focus on center content */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_20%,rgba(0,0,0,0.6)_100%)] z-20 pointer-events-none" />

      {/* Subtle dark overlay for text readability without tinting the video blue */}
      <div className="absolute inset-0 bg-black/30 z-10 pointer-events-none" />

      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        width={1920}
        height={1080}
        preload="metadata"
      >
        <source src={videoSrc} type="video/mp4" />
      </video>
    </div>
  )
}
